import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading streamers..." @subtitle="Finding gaming content creators and streamers" />
</template>
